import { t } from 'i18next';
import React, { useCallback } from 'react';

import UDatePicker from 'Components/unit/UDatePicker/UDatePicker';

import styles from './DateRangeInput.style';

type DateRangeInputProps = {
  startDate: Date | null;
  endDate: Date | null;
  handleFilterChange: (filterCategory: 'startDate' | 'endDate', value: Date) => void;
};

const DateRangeInput: React.FC<DateRangeInputProps> = ({ startDate, endDate, handleFilterChange }) => {
  const onChange = useCallback(
    (type: 'startDate' | 'endDate', date: Date) => {
      handleFilterChange(type, date);

      if (type === 'startDate' && endDate && date.getTime() > endDate.getTime()) {
        handleFilterChange('endDate', date);
      }

      if (type === 'endDate' && startDate && date.getTime() < startDate.getTime()) {
        handleFilterChange('startDate', date);
      }
    },
    [handleFilterChange, startDate, endDate],
  );

  return (
    <div style={styles.dateFiltersContainer}>
      <div style={styles.datePickerContainer}>
        <p style={styles.datePickerLabel}>{t('analytics:dashboard.campaigns.date_picker.from')}</p>
        <UDatePicker
          date={startDate}
          disabledDateContext={true}
          onClick={(date: Date) => onChange('startDate', date)}
        />
      </div>
      <div style={styles.datePickerContainer}>
        <p style={styles.datePickerLabel}>{t('analytics:dashboard.campaigns.date_picker.to')}</p>
        <UDatePicker date={endDate} disabledDateContext={true} onClick={(date: Date) => onChange('endDate', date)} />
      </div>
    </div>
  );
};

export default DateRangeInput;
